<template>
  <el-dialog
    :modal-append-to-body="false"
    :title="this.type != 'new' ? $t('app.edit') : $t('app.new')"
    :visible.sync="dialogVisible"
    width="600px"
  >
    <el-input
      v-model="name"
      size="small"
      :disabled="true"
      style="margin-bottom: 10px"
      :placeholder="$t('app.floorName')"
    >
    </el-input>
    <el-input
      id="RoomEdit_roomCode"
      v-model="code"
      size="small"
      :disabled="isDisabled()"
      style="margin-bottom: 10px"
      :placeholder="$t('app.roomCode')"
    >
    </el-input>
    <el-select
      v-model="roomType"
      size="small"
      :placeholder="$t('app.roomType')"
      style="margin-bottom: 20px; width: 100%"
    >
      <el-option
        v-for="item in roomTypeList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-input
      v-model="remark"
      size="small"
      type="textarea"
      :rows="2"
      placeholder="房間狀況備註"
    >
    </el-input>
    <el-divider content-position="left">{{ $t("app.bed") }}</el-divider>
    <el-row>
      <el-button
        style="margin-bottom: 5px"
        type="primary"
        size="small"
        @click="newBed"
        >{{ $t("app.new") }}</el-button
      >
      <br />
      <el-button-group
        v-for="(item, index) in bedList"
        :key="item.code"
        style="margin-right: 15px"
      >
        <el-button
          size="small"
          :style="{ backgroundColor: statusColorList[statusMap[item.status]] }"
          type="primary"
          @click="editBed(index, item)"
          >{{ item.code }}</el-button
        >
        <el-button
          size="small"
          type="danger"
          icon="el-icon-delete"
          @click="delBed(index, item)"
        ></el-button>
      </el-button-group>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="handleCancel">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
    <bed-edit ref="bedEdit" @handleSuccess="bedHandle"></bed-edit>
  </el-dialog>
</template>
<script>
import { addRoom, editRoom } from "@/api/systemManagement/roomManagement";
import BedEdit from "./BedEdit";
import { getBedColor } from "@/api/dormitoryManagement/list";
import { getRoomType } from "@/api/guest/appointment";
export default {
  components: {
    BedEdit
  },
  data() {
    return {
      roomTypeList: [
        { value: "1", label: "Single" },
        { value: "2", label: "Twin" },
        { value: "3", label: "Double" },
        { value: "4", label: "Suite" }
      ],
      statusList: [
        { value: "1", label: "Vacant Clean" },
        { value: "0", label: "Not Vacant Clean" }
      ],
      statusMap: {
        1: "OOO",
        2: "Vacant Clean",
        3: "Vacant Dirty",
        4: "Occupied",
        5: "Occupied/Luggage"
      },
      statusColorList: {},
      loading: false,
      dialogVisible: false,
      isFirstCheck: true,
      name: "",
      floor: "",
      code: "",
      remark: "",
      roomType: "",
      bedList: [],
      index: "",
      type: "",
      id: "",
      enable: Boolean
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getBedColor().then(res => {
        let obj = {};
        res.data.forEach(item => {
          obj[item.Text] = item.Color;
        });
        this.statusColorList = obj;
      });
      // 查询接口，取得房间类型 laotang 2023-04-12
      getRoomType().then(res => {
        this.roomTypeList = res.data.map(_ => {
          return {
            label: _.Text,
            value: _.Code,
            rate: _.Rate
          };
        });
      });
    },
    newBed() {
      this.$refs.bedEdit.new();
    },
    editBed(index, item) {
      this.$refs.bedEdit.edit(index, item);
    },
    delBed(index, item) {
      this.$confirm(this.$t("app.isDelete") + "?(" + item.code + ")").then(
        () => {
          this.bedList.splice(index, 1);
        }
      );
    },
    bedHandle(obj, index) {
      if (index !== false) {
        this.bedList.splice(index, 1, obj);
        return;
      }
      this.bedList.push(obj);
    },
    edit(index, row, name) {
      console.log(row);
      this.dialogVisible = true;
      this.id = row.id;
      this.name = name;
      this.code = row.code;
      this.roomType = row.type;
      this.remark = row.remark;
      this.index = index;
      this.enable = row.enable;
      this.floor = row.floorCode;
      this.bedList = row.bedList;
      this.type = "edit";
    },
    new(floor, name) {
      this.name = name;
      this.floor = floor;
      this.dialogVisible = true;
      this.type = "new";
      this.bedList = [];
      this.code = "";
      this.roomType = "";
      this.index = "";
      this.enable = null;
    },

    isDisabled() {
      // console.log("type: " + this.type);
      // console.log("code: " + this.code);
      // this.code = "123";
      // return this.type != "new" && this.code.startsWith("EAH-");
      //var bool = this.type != "new" && this.code.startsWith("EAH-") && this.isFirstCheck;
      // this.isFirstCheck = false;
      //console.log(this.isFirstCheck + "  isDisabled: " + bool);
      // return bool;
      return false;
    },
    handleClose() {
      this.loading = true;
      if (this.type === "edit") {
        editRoom({
          RoomIndex: this.code,
          RoomType: this.roomType,
          FloorCode: this.floor,
          IsUse: true,
          Remark: this.remark,
          Id: this.id,
          BedGroup: this.bedList.map(item => {
            return {
              BedCode: item.code,
              BedState: item.status,
              BedStateColor: ""
            };
          })
        })
          .then(() => {
            this.success();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        if (!this.code.startsWith("EAH-")) {
          this.$message({
            message: this.$t("app.roomIndexNotEAHstartWith"),
            type: "error"
          });
          this.loading = false;
          return;
        }
        addRoom({
          RoomIndex: this.code,
          RoomType: this.roomType,
          FloorCode: this.floor,
          Remark: this.remark,
          IsUse: false,
          BedGroup: this.bedList.map(item => {
            return {
              BedCode: item.code,
              BedState: item.status,
              BedStateColor: ""
            };
          })
        })
          .then(() => {
            this.success();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success"
      });
      if (this.type === "edit") {
        this.$emit("handleSuccess", this.index, {
          id: this.id,
          code: this.code,
          type: this.roomType,
          enable: this.enable,
          remakr: this.remark
        });
      } else {
        this.$emit("handleAdd");
      }
      this.loading = false;
      this.dialogVisible = false;
      this.isFirstCheck = false;
    },
    handleCancel() {
      this.$emit("handleSuccess");
      this.dialogVisible = false;
    }
  }
};
</script>
